import { Navigate, Outlet } from "react-router-dom";

const AuthGuard = () => {
  // Provjeravamo postoji li token u sustavu
  const isAuthenticated = localStorage.getItem("access_token");

  // Ako nema tokena, šalji ga na login, inače prikaži sadržaj (Outlet)
  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default AuthGuard;
